import React from "react";
import { GrowthReport } from "./types";
import { fmtN, screenLabel } from "./format";
import { Fx, Row, Sheet } from "./Sheet";

// "Where people leave" — the last screen of sessions that did not convert
// (founder: super important). Its own sheet so it never hides under Details.

export function ExitsSheet({ exits }: { exits: GrowthReport["exits"] }) {
  if (exits.rows.length === 0) {
    return (
      <>
        <Fx>No non-converting sessions in this window.</Fx>
        <div className="gr-muted gr-pad-top">Nothing to show yet.</div>
      </>
    );
  }
  const top = exits.rows[0];
  const head: Row[] = [
    { cls: "gr-sh-head", cells: [{ v: "Last screen seen", cls: "gr-sh-step" }, { v: "Sessions" }, { v: "Share" }, { v: "Path" }] },
  ];
  const rows: Row[] = exits.rows.map((r, i) => ({
    cells: [
      { v: screenLabel(r.screen), cls: "gr-sh-step" },
      { v: fmtN(r.sessions), cls: `gr-sh-num${i === 0 ? " gr-sh-leak" : ""}` },
      { v: exits.total > 0 ? `${Math.round((r.sessions / exits.total) * 100)}%` : "—", cls: "gr-sh-num" },
      { v: r.path ? (r.path === "dj" ? "Talent" : "Fan") : "—", cls: r.path ? undefined : "gr-sh-none" },
    ],
  }));
  return (
    <>
      <Fx>
        <b>{fmtN(exits.total)}</b> sessions left without converting — most often on <b>{screenLabel(top.screen)}</b>.
      </Fx>
      <Sheet cols={4} head={head} rows={rows} label="where people leave" />
      <div className="gr-note">Closing the app or tab counts as leaving. Counted per session, not per person.</div>
    </>
  );
}
